import { AddCircle, Delete, Edit, Save } from "@material-ui/icons";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DataGrid } from "@mui/x-data-grid";
import { GridToolbar, } from '@mui/x-data-grid-premium';
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useCreateServiceMutation, useDeleteServiceListMutation, useGetAllServiceQuery, useGetServiceQuery, useLazyGetServiceDetailsByIDQuery, useUpdateServiceListMutation } from "../../../../../features/service/serviceDetailSlice";
import errorHandler from "../../../../hooks/ErrorHanlder";


const CreateService = () => {
  const { register, handleSubmit, formState: { errors }, reset, setValue } = useForm();
  const { data: serviceList, refetch } = useGetAllServiceQuery()
  const { data: serviceD, refetch: serviceData } = useGetServiceQuery()

  const [addService] = useCreateServiceMutation()
  const [deleteServiceList] = useDeleteServiceListMutation()
  const [updateServiceList] = useUpdateServiceListMutation()
  const [getServiceDetails, Results] = useLazyGetServiceDetailsByIDQuery()
  const serviceDetails = Results?.data?.data
  const [open, setOpen] = useState(false);
  const [deleteId, setDeleteId] = useState()
  const handleClose = async () => {
    setOpen(false);
    var result = await deleteServiceList(deleteId);
    if (result?.data.statusCode == 200) {
      toast.success("Service deleted successfully", { position: "top-center", })
      refetch();
    }
  };

  const [isShow, setIsShow] = useState(false);
  const [show, setShow] = useState(false)
  const [service, setService] = useState('')
  const [addServiceList, setAddServiceList] = useState([])
  const [rateTypeValue, setRateTypeValue] = useState("");
  const [cutoffChecked, setCutoffChecked] = useState(false);
  const [deliveryDay, setDeliveryDay] = useState("Same Day");
  const [serviceBookingCutoff, setServiceBookingCutoff] = useState("")
  const [deliverBy, setDeliverBy] = useState("");

  useEffect(() => {
    reset(serviceDetails)
    setService(serviceDetails)
  }, [serviceDetails])

  useEffect(() => {
    if (service) {
      setValue("description", service?.description)
      setValue("rateType", service?.rateType)
      setRateTypeValue(service?.rateType);
      //setValue("distanceBased", service?.distanceBased)
      setValue("serviceTimeframeUnit", service?.serviceBookingCutoff)
      //setValue("serviceTimeframe", service?.serviceTimeframe)

      if (service?.rateType === "LOCAL") {
        setCutoffChecked(service?.cutoffTime);

        if (service?.cutoffTime) {
          setDeliveryDay(service?.deliveryDay);
          setDeliverBy(convertTo12HourFormat(service?.deliverBy));
        } else {
          setValue("serviceTimeframe", service?.serviceTimeframe || 0);
        }
      }
      else {
        setDeliveryDay("");;
      }
      setServiceBookingCutoff(convertTo12HourFormat(service?.serviceBookingCutoff));
      setDeliverBy(convertTo12HourFormat(service?.deliverBy));
    }
  }, [service])

  const onSubmit = async (addServiceList) => {
    try {
      const newService = {
        ...addServiceList, serviceId: 0, cutoffTime: cutoffChecked, deliveryDay: cutoffChecked && rateTypeValue === "LOCAL" ? deliveryDay : "",
        serviceBookingCutoff: serviceBookingCutoff.toLocaleTimeString('en-GB'),
        deliverBy: cutoffChecked ? deliverBy.toLocaleTimeString('en-GB') : "", serviceTimeframe: addServiceList.serviceTimeframe || 0
      }
      setAddServiceList(newService);
      const addData = await addService(newService);
      if (addData?.data?.statusCode === 200) {
        toast.success(addData?.data?.message, {
          position: "top-center",
        })
      } else {
        errorHandler(addData)
      }
      reset({ description: '', rateType: "", distanceBased: "", serviceTimeframe: "", serviceTimeframeUnit: "" });
      setCutoffChecked(false);
      setDeliveryDay("Same Day");
      setServiceBookingCutoff("")
      setDeliverBy("");
      setRateTypeValue("Select")
      refetch()
      serviceData()
    } catch (error) {
      errorHandler(error)
    }
  }

  const convertTo12HourFormat = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(':');
    const period = hours >= 12 ? 'PM' : 'AM';
    let adjustedHours = (hours % 12 || 12).toString().padStart(2, '0');
    if (time.includes("AM") || time.includes("PM")) {
      return time; // Already formatted
    }
    return `${adjustedHours}:${minutes} ${period}`;
  }

  const onUpdate = async (data) => {
    let formattedServiceBookingCutoff = serviceBookingCutoff;
    // Check if serviceBookingCutoff is a Date object or a date string that needs formatting
    if (serviceBookingCutoff instanceof Date || Date.parse(serviceBookingCutoff)) {
      formattedServiceBookingCutoff = new Date(serviceBookingCutoff).toLocaleTimeString('en-GB');
    }

    let formattedDeliverBy = cutoffChecked && (deliverBy instanceof Date || Date.parse(deliverBy))
      ? new Date(deliverBy).toLocaleTimeString('en-GB')
      : deliverBy;

    const updatedService = {
      ...data,
      serviceBookingCutoff: formattedServiceBookingCutoff,  // Ensure the latest time is passed
      deliverBy: formattedDeliverBy,   // Include deliverBy if cutoffChecked is true
      serviceTimeframe: cutoffChecked ? 0 : (data.serviceTimeframe ?? 0),
      deliveryDay: cutoffChecked && rateTypeValue === "LOCAL" ? deliveryDay : "",
    };
    const updateData = await updateServiceList(updatedService);
    if (updateData?.data?.statusCode === 200) {
      toast.success("Data Updated Sccessfully !", {
        position: "top-center",
      });
      setShow(false);
      setCutoffChecked(false);
      setDeliveryDay("Same Day");
      setServiceBookingCutoff("");
      setDeliverBy("");
      setRateTypeValue("Select");
      reset({ description: '', rateType: "", distanceBased: "", serviceTimeframe: "", serviceTimeframeUnit: "" });
      refetch()
      serviceData()
    }
    else {
      errorHandler(updateData)
    }
  }

  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 120,
      disableClickEventBubbling: true,
      renderCell: (data) => {
        const onClick = (e) => {
          e.stopPropagation();
          getServiceDetails(data.row.id)
          setShow(true)
        };
        const onRemove = (e) => {
          e.stopPropagation();
          setDeleteId(data?.id)
          setOpen(true);
        };

        return (
          <>
            <>
              <div className="action_btn">
                <span className="edit_btn" onClick={onClick}><Edit /></span>
                <span className="del_btn" onClick={onRemove}><Delete /></span>
              </div>
            </>
            <>
              <div>
                <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" >
                  <DialogTitle id="alert-dialog-title">
                    Delete Confirmation
                  </DialogTitle>
                  <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                      Are you sure you want to delete this row?
                    </DialogContentText>
                  </DialogContent>
                  <DialogActions>
                    <Button className="btn-secondary" onClick={() => { setOpen(false); }}>Cancel</Button>
                    <Button className="btn-primary" onClick={() => { handleClose(); }} autoFocus> Confirm</Button>
                  </DialogActions>
                </Dialog>
              </div>
            </>
          </>
        )

      },
    },
    { field: "description", headerName: "Service Type", width: 220 },
    { field: "rateType", headerName: "Rate Type", width: 260 },
    // { field: "distanceBased", headerName: "Distance Based", width: 220 },
    { field: "serviceTimeframeUnit", headerName: "Service Booking Cutoff", width: 220 },
    { field: "serviceTimeframe", headerName: "Service Time Frame", width: 220 },
    { field: "cutoff", headerName: "Cutoff", width: 150 },
    { field: "deliverBy", headerName: "Deliver By", width: 180 },
  ];
  const rows =
    (serviceList?.data || []).map((data) => {
      return {
        id: data?.serviceId,
        description: data?.description,
        rateType: data?.rateType,
        distanceBased: data?.distanceBased,
        serviceTimeframe: data?.serviceTimeframe || "",
        serviceTimeframeUnit: data?.serviceBookingCutoff ? convertTo12HourFormat(data?.serviceBookingCutoff) : "",
        cutoff: data?.deliveryDay,
        deliverBy: data?.deliverBy ? convertTo12HourFormat(data?.deliverBy) : "",
      }
    })

  return (
    <>
      <Button onClick={() => setIsShow(true)} variant="primary" style={{ width: "20%" }}>
        Create Service
      </Button>
      <Modal
        size="lg"
        show={isShow}
        onHide={() => setIsShow(false)}
        aria-labelledby="example-modal-sizes-title-md"
        id="product-desp"
      >
        <Modal.Header closeButton>
          <Modal.Title id="example-modal-sizes-title-md">
            Add Service
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col >
              <div className="form-floating">
                <Form.Control type="text" placeholder="Service Type" name="description" {...register('description', { required: 'Field is required' })} />
                <label htmlFor="Service Type">Service Type</label>
              </div>
              <p className="error-message">{errors.description?.message}</p>
            </Col>
            <Col >
              <div className="form-floating">
                <Form.Select aria-label="Floating label select example" name="rateType" {...register('rateType')} onClick={(e) => setRateTypeValue(e.target.value)}>
                  <option>Select</option>
                  <option value="LOCAL">Local</option>
                  <option value="CWT">CWT</option>
                  <option value="PALLET">PALLET</option>
                  <option value="DISTANCE-BASED">DISTANCE-BASED</option>
                </Form.Select>
                <label htmlFor="accessoial">Rate Type</label>
              </div>
              <p className="error-message">{errors.rateType?.message}</p>
            </Col>
            {/* <Col >
              <div className="form-floating">
                <Form.Select aria-label="Floating label select example" name="distanceBased" {...register('distanceBased')}>
                  <option>Select</option>
                  <option value="true">YES</option>
                  <option value="false">NO</option>
                </Form.Select>
                <label htmlFor="accessoial">Distance-based</label>
              </div>
              <p className="error-message">{errors.distanceBased?.message}</p>
            </Col> */}
            <Col >
              <div className="form-floating">
                {/* <Form.Select aria-label="Floating label select example" name="serviceTimeframeUnit" {...register('serviceTimeframeUnit')}>
                  <option value="">Select</option>
                  <option value="H">Hourly</option>
                  <option value="D">Daily</option>
                </Form.Select>
                <label htmlFor="accessoial">Select Service Time Frame</label> */}
                <TimePickerComponent
                  allowEdit={false}
                  format="hh:mm a"
                  placeholder="Service booking cutoff"
                  value={serviceBookingCutoff}
                  name="serviceTimeframeUnit"
                  {...register('serviceTimeframeUnit')}
                  onChange={(e) => setServiceBookingCutoff(e.target.value)}  // Update the state on change
                />
              </div>
              <p className="error-message">{errors.serviceTimeframeUnit?.message}</p>
            </Col>
            {rateTypeValue === "LOCAL" &&
              <>
                <Col sm={1}>
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input" name="cutoffTime"
                      onClick={() => { setCutoffChecked(!cutoffChecked) }} checked={cutoffChecked} />
                    <label title="" htmlFor="formBasicCheckbox" className="form-check-label">Cutoff Time</label>
                  </div>
                </Col>
                {cutoffChecked ?
                  <> <Col sm={1}>
                    <div class="field radio_field">
                      <label className="form-check-label"><input onClick={() => setDeliveryDay("Same Day")} className="form-check-input" type="radio" name="deliverBy" checked={deliveryDay === "Same Day"} />
                        Same Day</label>
                      <label className="form-check-label"><input onClick={() => setDeliveryDay("Next Day")} className="form-check-input" type="radio" name="deliverBy" checked={deliveryDay === "Next Day"} />
                        Next Day</label>
                    </div>
                  </Col>
                    <Col>
                      <TimePickerComponent allowEdit={false}
                        format="hh:mm a" placeholder="Deliver by" value={deliverBy} onChange={(e) => setDeliverBy(e.target.value)} />
                    </Col>  </> :
                  <Col >
                    <div className="form-floating">
                      <Form.Control type="Number" placeholder="Service TimeFrame" name="serviceTimeframe" {...register('serviceTimeframe')} onChange={(e) => setValue('serviceTimeframe', e.target.value)} />
                      <label htmlFor="Service TimeFrame">Service Time Frame</label>
                    </div>
                    <p className="error-message">{errors.serviceTimeframe?.message}</p>
                  </Col>} </>}
            <Col sm={1}>
              {!show ?
                <div className="section_action_btn">
                  <div className="add_btn"><button type="button" className="btn" onClick={handleSubmit(onSubmit)} ><AddCircle /> Add</button></div>
                </div>
                :
                <div className="section_action_btn">
                  <div className="save_btn"><button type="button" className="btn" onClick={handleSubmit(onUpdate)} ><Save /> Save</button></div>
                </div>
              }
            </Col>
          </Row>
          <div className="user-role-table" style={{ height: "500px" }}>
            <h6>List of history</h6>
            <DataGrid rows={rows} columns={columns} pageSize={15} rowsPerPageOptions={[1]} components={{ Toolbar: GridToolbar }} />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};
export default CreateService;
